import { Icon, IconsEnum } from 'components/Icons';
import React, { useState } from 'react';

import { SportNavFilters } from '../sportNavFilters/SportNavFilters';
import classNames from 'classnames';
import { selectIsFilterChanged } from 'features/sport/selectors';
import styles from './SportNavFiltersTrigger.module.scss';
import { useTypedSelector } from 'lib/centralStore';

export type SportNavFiltersTriggerProps = {
  children?: React.ReactNode;
  disabled?: boolean;
};

export const SportNavFiltersTrigger = ({ children, disabled = false }: SportNavFiltersTriggerProps) => {
  const [filtersVisibility, setFiltersVisibility] = useState<boolean>(false);
  const isFilterChanged = useTypedSelector(selectIsFilterChanged);

  const onButtonClickHandler = () => {
    if (disabled) return;
    setFiltersVisibility(true);
  };

  return (
    <React.Fragment>
      <button type="button" className={styles.button} disabled={disabled} onClick={onButtonClickHandler}>
        {children}
        <span
          className={classNames(styles.iconWrapper, {
            // [styles['iconWrapper-hidden']]: !isTruthy(filters?.length),
            [styles.filterChanged]: isFilterChanged,
          })}
        >
          <Icon iconId={IconsEnum.FILTER} className={styles.icon} color="var(--color-on-bg-secondary)" />
        </span>
      </button>
      <SportNavFilters visibility={filtersVisibility} handleClose={setFiltersVisibility} />
    </React.Fragment>
  );
};
